import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const reportCardAPI = createApi({
    reducerPath: "reportCardAPI",
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getContractReportCardDetails: builder.query({
            query: (plContractKey) => ({
                url: `Contract/GetContractReportCardDetails?plContractKey=${plContractKey}`,
                method: "GET",
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getContractExpenseBreakdown: builder.query({
            query: (plContractKey) => ({
                url: `Contract/GetContractExpenseBreakdown?plContractKey=${plContractKey}`,
                method: "GET",
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const { useLazyGetContractReportCardDetailsQuery, useLazyGetContractExpenseBreakdownQuery } = reportCardAPI;

export default reportCardAPI;